export default "__VITE_ASSET__rbI9825u__"